import React from 'react';
import PropTypes from 'prop-types';
import HoverTooltip from '@Components/HoverTooltip/HoverTooltip';
import { ButtonWithIcon } from '@els/els-react--button';
import { noop } from 'lodash/noop';

function PreFooter({ alertsInfo }) {
  const { maxDocumentsPerEmail } = alertsInfo;

  return (
    <div className="create-alert-dialog-flex-row">
      Email alerts will produce an email with a maximum of {maxDocumentsPerEmail} records.
      <HoverTooltip
        width="15rem"
        placement="top"
        tooltip={`Emails will be limited in size and restricted to ${maxDocumentsPerEmail} records or 10Mb (depending on which is reached first)`}>
        <ButtonWithIcon
          iconOnly
          type="link"
          linkIconSize="s"
          size="small"
          className="u-els-margin-left-1o2"
          e2eName="info-tooltip-alert-max-documents-per-email"
          sprite="InformationOutlineCircle"
          onClick={() => noop()}
          a11y={{ name: 'Alert info', description: 'Alert information' }}>
          alert info
        </ButtonWithIcon>
      </HoverTooltip>
    </div>
  );
}

PreFooter.propTypes = {
  alertsInfo: PropTypes.object.isRequired,
};

export default PreFooter;
